<template>
  <div>
    <script
      type="application/ld+json"
      v-html="schema"
    />
  </div>
</template>
<script>
  import createCloudinaryUrl from '@/vue/components/common/picture/createCloudinaryUrl.vue'

  export default {
    name: "PageSchema",
    mixins: [createCloudinaryUrl],
    props: {
      type: {
        type: String,
        default: "Article"
      },
      headline: {
        type: String,
        default: ""
      },
      // sizes and image props are inherited from mixins createCloudinaryUrl/commonPictureConfig
      datePublished: {
        type: String,
        default: ""
      },
      dateModified: {
        type: String,
        default: ""
      },
      // Hardcoded dpr to deliver bigger images to google (important for small and medium formats)
      manualDpr: {
        type: Number || null,
        default: 2
      },
    },
    computed: {
      getImageUrls () {
        let images = []

        if (this.image.small) {
          images.push(this.getCloudinaryUrl(this.image.small, this.sizes.small))
        }
        if (this.image.medium) {
          images.push(this.getCloudinaryUrl(this.image.medium, this.sizes.medium))
        }
        if (this.image.large) {
          images.push(this.getCloudinaryUrl(this.image.large, this.sizes.large))
        }

        return images
      },
      schema () {
        return {
          "@context": "https://schema.org",
          "@type": this.type,
          "headline": this.headline,
          "image": this.image ? this.getImageUrls : null,
          "datePublished": this.datePublished, // "2015-02-05T08:00:00+08:00",
          "dateModified": this.dateModified,
          "author": {
            "@type": "Organization",
            "name": "ICA",
          }
        }
      }
    }
  }
</script>
